module.exports = __webpack_public_path__ + "static/media/save.6882ddc7.svg";